import Visible from '@portalterreno/react-ui/Visible';
import Portal from '@portalterreno/react-ui-core/Portal';
import { FC, Fragment, useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { cancelMultipleLeads } from '../../../redux/slices/multipleLeads';
import { RootState } from '../../../redux/store';
import RelatedPropertiesSuccessModal from '../RelatedPropertiesSuccessModal';
import Desktop from './Desktop';
import Mobile from './Mobile';

const RelatedPropertiesLeadModal: FC = () => {
  const dispatch = useDispatch();

  const state = useSelector(
    (state: RootState) => ({
      isModalOpen: state.multipleLeads.isModalOpen,
      relatedProperties: state.multipleLeads.relatedProperties
    }),
    shallowEqual
  );

  const handleOnClose = useCallback(() => {
    dispatch(cancelMultipleLeads());
  }, [dispatch]);

  return (
    <Fragment>
      <Visible desktop>
        <Desktop
          isOpen={state.isModalOpen}
          onClose={handleOnClose}
          relatedProperties={state.relatedProperties}
        />
      </Visible>
      <Visible mobile>
        <Mobile
          isOpen={state.isModalOpen}
          onClose={handleOnClose}
          relatedProperties={state.relatedProperties}
        />
      </Visible>
      <Portal>
        <RelatedPropertiesSuccessModal />
      </Portal>
    </Fragment>
  );
};

export default RelatedPropertiesLeadModal;
